<template>
  <Select
    ref="selectRef"
    v-model="myValue"
    :size="size"
    :disabled="disabled"
    :clearable="clearable"
    :filterable="filterable"
    :allow-create="allowCreate"
    :class="className"
    @on-change="changeValue"
    @on-create="createItem"
    @on-open-change="openChange"
    @on-clear="clear"
  >
    <Option
      v-for="item in list"
      :key="item.name || item"
      :value="item.name || item"
      :label="item.name || item"
      :disabled="item.disabled || false"
    >
      <span class="title">{{ item.name || item }}</span>
    </Option>
  </Select>
</template>

<script>
export default {
  name: 'TempalteSelector',
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    size: { type: String, default: 'large' },
    className: { type: String, default: '' }, // custom-select
  },

  data() {
    return {
      list: [],
      myValue: '',
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.myValue = newVal
      },
    },
    myValue: {
      immediate: true,
      handler(newVal) {
        this.$emit('input', newVal)
      },
    },
  },

  methods: {
    async init() {
      this.list = await this.getList()
    },

    // fixed: manual modification of values does not take effect
    reload(val) {
      this.init()
      this.myValue = val
    },

    getList() {
      return new Promise((resolve) => {
        resolve(['test1', 'test2'])
      })
    },

    changeValue(val) {
      if (val === undefined) {
        this.myValue = this.value
        return this.myValue
      }

      this.$nextTick(() => {
        this.myValue = val
        let itemValue = val
        if (val) {
          itemValue = this.list.find((item) => item?.name === val || item === val)
        }
        this.$emit('onChange', itemValue)
      })
      return this.myValue
    },

    // only supprot like '['test1', 'test2']' format array
    createItem(val) {
      this.list.push(val)
    },
    openChange(val) {
      this.$emit('onOpenChange', val)
    },
    clear() {
      this.$emit('clear')
    },
  },
}
</script>
